﻿



// Write your JavaScript code.
const css = require('../css/site.scss');
window.$ = window.jQuery = $;
import 'bootstrap';

window.resizeBlogVideos = function () {
    // Find all YouTube videos
    // Expand that selector for Vimeo and whatever else
    var $allVideos = $("iframe[src^='//www.youtube.com']"),

        // The element that is fluid width
        $fluidEl = $(".post");

    // Figure out and save aspect ratio for each video
    $allVideos.each(function () {

        $(this)
            .data('aspectRatio', this.height / this.width)

            // and remove the hard coded width/height
            .removeAttr('height')
            .removeAttr('width');

    });

    // When the window is resized
    $(window).resize(function () {

        var newWidth = $fluidEl.width();

        // Resize all videos according to their own aspect ratio
        $allVideos.each(function () {

            var $el = $(this);
            $el
                .width(newWidth)
                .height(newWidth * $el.data('aspectRatio'));

        });

        // Kick off one resize to fix all videos on page load
    }).resize();
}


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/app.js
// module id = 135
// module chunks = 2